// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"515e5c6a","911":"515e5c6a","980":"2b36a572"}[chunkId] + ".chunk.css";
};